export default {"src":"/_next/static/media/medical-id.3aa04ed0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};